/** Shared styling for every back-navigation control so they all use the brand navy. */
export const BACK_BUTTON_NAVY = "#04305c";
export const BACK_BUTTON_NAVY_HOVER = "#032a50";

const navyFilledRoot = {
  backgroundColor: BACK_BUTTON_NAVY,
  color: "#fff",
  borderColor: BACK_BUTTON_NAVY,
  fontWeight: 600,
  "&:hover": {
    backgroundColor: BACK_BUTTON_NAVY_HOVER,
    color: "#fff",
    borderColor: BACK_BUTTON_NAVY_HOVER,
  },
} as const;

/** Filled back buttons: navy background, white label. */
export const backButtonFilledStyles = {
  root: navyFilledRoot,
  label: { color: "#fff" },
  section: { color: "#fff" },
} as const;

/**
 * Same navy fill as `backButtonFilledStyles`.
 * Kept as an alias so existing imports stay navy-filled instead of gray chips.
 */
export const backButtonQuietStyles = backButtonFilledStyles;
